import { hasValue } from "../../../utils/functions.js";

import TableList from "../../sub-components/Generic/TableList/TableList.vue";

export default {
  name: "MerchantContact",
  components: {
    TableList
  },
  data() {
    return {
      permissionIsAuthorize: 'MerchantContact',
      modalTitle: "Notificações",
      countFilter: 0,
      itemList: [],
      profiles: [],
      idContato: null,
      idMerchant: 0,
      checkAlertas: false,
      filter: {
        Id: 0,
        IdMerchant: null,
        IdContatoCategoria: null,
        Identity: null,
        Profile: null,
        Name: null,
        Email: null,
        Phone: null,
        CategoryName: null
      },
      idField: 0,
      notifications: [
        { key: 'AlertaAtualizacaoSistema', label: 'Atualização de Sistema' },
        { key: 'AlertaInstabilidade', label: 'Instabilidade' },
        { key: 'AlertaMensalidade', label: 'Mensalidade' },
        { key: 'AlertaNewsletter', label: 'Newsletter' },
        { key: 'AlertaNotaFiscal', label: 'Nota Fiscal' },
      ],
      itemGet: {
        Name: null,
        AlertaAtualizacaoSistema: null,
        AlertaInstabilidade: null,
        AlertaMensalidade: null,
        AlertaNewsletter: null,
        AlertaNotaFiscal: null
      },
      isSeeing: false,
      loading: false,
      pOpened: null,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      validatedFieldForm: false
    };
  },

  mounted() {
    this.idMerchant = Number(this.$route.params.idMerchant);
    this.ListContactCategory();
    this.ListMerchantContact();
  },

  methods: {
    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },

    Filter() {
      this.$bvModal.hide("mFilter");
      this.ListMerchantContact();
    },

    ResetFilter() {
      this.filter = {
        Id: 0,
        IdMerchant: null,
        IdContatoCategoria: null,
        Identity: null,
        Profile: null,
        Name: null,
        Email: null,
        Phone: null,
        CategoryName: null
      };
      this.ListMerchantContact();
    },

    ResetItemGet() {
      this.idContato = null;
      this.itemGet = {
        Name: null,
        AlertaAtualizacaoSistema: null,
        AlertaInstabilidade: null,
        AlertaMensalidade: null,
        AlertaNewsletter: null,
        AlertaNotaFiscal: null
      };
      this.checkAlertas = null;
      this.idField = 0;
      this.isSeeing = false;
      this.loading = false;
      this.pOpened = null;
    },

    ListMerchantContact() {
      this.loading = true;
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      if (hasValue(this.filter.Email)) this.countFilter++;
      if (hasValue(this.filter.Profile)) this.countFilter++;

      let data = {
        ...this.pagination,
        "Object.Id": this.idMerchant,
        "Object.IdContatoCategoria": this.filter.IdContatoCategoria,
        "Object.Name": this.filter.Name,
        "Object.Identity": this.filter.Identity,
        "Object.Email": this.filter.Email,
        "Object.Profile": this.filter.Profile
      };
      delete data.TotalItems;
      this.$store.dispatch("ListMerchantContact", data)
        .then(response => {
          this.itemList = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao listar os campos. Tente novamente.",
            "danger", "Erro ao listar os Campos", error);
        })
        .finally(() => (this.loading = false));
    },

    OpenModalGet(e, i, view) {
      this.idContato = i;
      this.GetMerchantContact(i);
      this.$bvModal.show("mGet");
    },

    CheckAlertas() {
      if (
        this.itemGet.AlertaAtualizacaoSistema == true ||
        this.itemGet.AlertaInstabilidade == true ||
        this.itemGet.AlertaMensalidade == true ||
        this.itemGet.AlertaNewsletter == true ||
        this.itemGet.AlertaNotaFiscal == true) 
      {
        this.checkAlertas = true;
      }
    },

    GetMerchantContact(id) {
      this.ResetItemGet();
      this.loading = true;
      this.$store.dispatch("GetMerchantContact", { id: id })
        .then(response => {
          this.itemGet = response;
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao carregar o campo", "danger", "Erro ao carregar o campo", error);
        })
        .finally(() => {
          this.loading = false;
          this.CheckAlertas();
        });
    },

    ListContactCategory() {
      let data = {
        ...this.pagination,
      };
      this.$store.dispatch("ListContactCategory", data)
        .then(response => {
          this.profiles = response.Objects;
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao listar os campos. Tente novamente.",
            "danger", "Erro ao listar os Campos", error);
        })
        .finally(() => (this.loading = false));

    },
  }
};


// WEBPACK FOOTER //
// ./src/components/pages/MerchantContact/MerchantContact.js